import type { InputSize as DSInputSize } from '@ds/primitives/input'

import { InputSize } from './types'

/*
 * The legacy seven-step size scale, folded onto @ds's three for a DS control
 * placed in a legacy screen. Each step goes to the DS height closest to its own
 * (xs 26px…sm 30px → 34px, default 38px…lg 42px → 40px, xl 50px → 46px).
 *
 * A migration bridge: it lives on the legacy side because @ds must not know the
 * legacy scale, and it goes when the last legacy caller does.
 */
export const toDSInputSize = (size?: InputSize): DSInputSize => {
  switch (size) {
    case 'xxs':
    case 'xs':
    case 'sm':
      return 'sm'
    case 'xl':
    case '2xl':
      return 'lg'
    default:
      return 'md'
  }
}
